import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { BotonTipo } from '../../../../components/boton/boton';
import { MatDialog, MatSnackBar } from '@angular/material';
import { EliminarEntidadResponsableDialog } from './eliminar-entidad-responsable-dialog/eliminar-entidad-responsable-dialog.component';

@Component({
  selector: 'app-eliminar-entidad-responsable',
  templateUrl: './eliminar-entidad-responsable.component.html',
  styleUrls: ['./eliminar-entidad-responsable.component.scss']
})
export class EliminarEntidadResponsableComponent implements OnInit {
  @Output() onEliminado = new EventEmitter();
  @Input() type: BotonTipo;
  @Input() disabled: boolean = false;
  @Input() tooltipDir: string = 'below';
  @Input() IdEntidadResponsable?: number | string;

  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    if (!this.IdEntidadResponsable) {
      throw "La variable Input 'IdEntidadResponsable' es requerida";
    }
  }

  openDialog(): void {
    let dialogEliminar = this.dialog.open(EliminarEntidadResponsableDialog, {
      disableClose: true,
      data: {
        IdEntidadResponsable: this.IdEntidadResponsable
      }
    });

    dialogEliminar.afterClosed().subscribe(resultado => {
      if (resultado && resultado.estado && resultado.estado == 1) {
        this.onEliminado.emit();
        this.snackBar.open(resultado.mensaje, 'OK', { duration: 2750 });
      }
    });
  }
}
